import { User } from "../../../features/user";
import { hasEntitlement } from "../../../utils/has-entitlement";
import {
  localStorageFeatureToggle,
  FeatureName,
} from "../../../utils/feature-toggle-utils";

// Single source of truth for whether the Integrations surface is visible
// (SKE-3972). Production gate = the `external-integrations` entitlement (the
// org-level rollout signal, mirrored server-side in featureAccess.ts). Internal
// users can preview without the entitlement via the localStorage dev override.
// Used by BOTH side-nav and profile-settings so the nav item and the section
// content are gated identically (no flash of gated content — the whole page waits
// on the profile query before either renders).
export function hasExternalIntegrationsAccess(user: User): boolean {
  return (
    hasEntitlement(user, "external-integrations") ||
    localStorageFeatureToggle.get(FeatureName.ExternalIntegrations)
  );
}

// Whether the user may CONFIGURE integrations (connect / reconnect / disconnect /
// save config), as opposed to just VIEW them (SKE-3956). Visibility stays
// entitlement-based via hasExternalIntegrationsAccess; this is the separate
// role/permission check. Admins/owners always may; a collaborator may only when an
// admin has turned on `canConfigureIntegrations` (default off). Mirrors the server
// gate `requireIntegrationsManageAccess`.
export function canManageIntegrations(user: User): boolean {
  if (user.role === "admin") {
    return true;
  }
  return user.preferences?.canConfigureIntegrations === true;
}
